import Fraction from '../components/Fraction';

export default function CompareQuestion({ question, onAnswer, disabled }) {
  const { num1, den1, num2, den2 } = question.data;

  return (
    <div className="question-card">
      <p className="question-prompt">{question.prompt}</p>
      <div className="compare-fractions">
        <Fraction num={num1} den={den1} size="lg" />
        <span style={{ color: 'var(--color-muted)', fontSize: '1.2rem' }}>?</span>
        <Fraction num={num2} den={den2} size="lg" />
      </div>
      <div className="compare-op-buttons">
        {['<', '=', '>'].map(op => (
          <button
            key={op}
            className="compare-op-btn"
            onClick={() => onAnswer(op)}
            disabled={disabled}
          >
            {op}
          </button>
        ))}
      </div>
    </div>
  );
}
